import React from 'react';
import { Phone, Mail, X } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { useLanguage } from '../context/LanguageContext';
import MaskedPhone from './MaskedPhone';
import './ContactBrokerModal.css';

export default function ContactBrokerModal({ broker, isOpen, onClose }) {
  const { user } = useAuth();
  const { t } = useLanguage();
  if (!isOpen || !broker) return null;

  const name  = broker.full_name || broker.name || broker.agency_name || t('contactBroker.fallbackName');
  const phone = broker.phone || broker.broker_phone;
  const email = broker.email || broker.broker_email;

  return (
    <div className="contactModal__backdrop" onClick={onClose}>
      <div className="contactModal" onClick={(e) => e.stopPropagation()}>
        <button
          className="contactModal__close"
          onClick={onClose}
          aria-label={t('contactBroker.closeAria')}
        >
          <X size={20} />
        </button>

        <h3 className="contactModal__title">{t('contactBroker.titlePrefix')}{name}</h3>
        <p className="contactModal__subtitle">{t('contactBroker.subtitle')}</p>

        <div className="contactModal__options">
          <div className="contactModal__option contactModal__option--phone">
            <Phone size={20} />
            <div className="contactModal__option-body">
              <strong>{t('contactBroker.call')}</strong>
              {/* Broker phones still come from the public `brokers` row until a
                  get_broker_contact RPC lands. For logged-out users MaskedPhone
                  never renders the value into the DOM — but it does still sit
                  in JS memory; full data-layer gating needs that follow-up RPC. */}
              <MaskedPhone phone={phone} />
            </div>
          </div>

          {user && email && (
            <a href={`mailto:${email}`} className="contactModal__option">
              <Mail size={20} />
              <div>
                <strong>{t('contactBroker.email')}</strong>
                <span>{email}</span>
              </div>
            </a>
          )}

          {user && !phone && !email && (
            <p className="contactModal__empty">
              {t('contactBroker.empty')}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
